import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberRegistrationStepForm from '../../../components/forms/MemberRegistrationStepForm';
import { useMemberRegistrationStepById, useUpdateMemberRegistrationStep } from '../../../hooks/useMemberRegistrationStepApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { MemberRegistrationStepDTO } from '../../../services/apiClient';

const MemberRegistrationStepEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useMemberRegistrationStepById(id!);
  const updateMutation = useUpdateMemberRegistrationStep();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Registration Steps', href: '/admin/memberregistrationsteps' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/memberregistrationsteps');
    } catch (error) {
      console.error('Error updating MemberRegistrationStep:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberregistrationsteps"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberRegistrationStep.Edit'
    >
        {entityData ? (
          <MemberRegistrationStepForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/memberregistrationsteps')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberRegistrationStepEdit;